import {Box, Button, Grid, Stack, Text} from '@primer/react-brand/esm'

import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import type {PrimerComponentSectionIntro} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSectionIntro'

import type {GenericContent} from '../../../../brand/lib/types/contentful'

import IdeList from '../_components/IdeList/IdeList'

type Props = {
  content: {
    sectionIntro?: PrimerComponentSectionIntro
    cta?: GenericContent
  }
}

export function CtaSection({content}: Props) {
  const {sectionIntro, cta: featuresCopilotPlansCta} = content
  const ctaLink = featuresCopilotPlansCta?.fields.links?.at(0)

  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <Grid as="section" className="lp-Section tmp-pt-5 tmp-pt-lg-8 tmp-pb-8">
      <Grid.Column span={{xsmall: 12, small: 8}} start={{xsmall: 1, small: 3}}>
        <Stack direction="vertical" gap={40} className="text-center p-0">
          {sectionIntro ? (
            <ContentfulSectionIntro component={sectionIntro} fullWidth headingSize="3" className="p-0" />
          ) : null}

          <IdeList type="big" location="pricing-cta" />

          {featuresCopilotPlansCta ? (
            <Box>
              <Text size="300" weight="normal" variant="muted">
                {featuresCopilotPlansCta.fields.heading}
              </Text>

              {ctaLink ? (
                <Box marginBlockStart={24}>
                  <Button
                    as="a"
                    href={ctaLink.fields.href}
                    variant={ctaLink.fields.variant || 'subtle'}
                    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
                    className="lp-Features-secondaryButton"
                    {...getAnalyticsEvent({
                      action: ctaLink.fields.text,
                      tag: 'button',
                      context: 'ide_list',
                      location: 'cta',
                    })}
                  >
                    {ctaLink.fields.text}
                  </Button>
                </Box>
              ) : null}
            </Box>
          ) : null}
        </Stack>
      </Grid.Column>
    </Grid>
  )
}
